import { FloodlightTracker } from './floodlight';
import { FacebookPixel } from './facebook';
import { Adwords } from './adwords';
import bing from 'app/client/bing';
import type { ListingDetails } from 'app/types/listingDetails.type';

export function trackForRentContact(listing: Partial<ListingDetails>): void {
  FloodlightTracker.trackForRentContact(listing);
  FacebookPixel.trackForRentContact(listing);
  Adwords.trackForRentContact(listing);
  bing.trackForRentContact({
    trusted: listing.trusted ?? false,
    isApartmentBldg: listing.isApartmentBldg ?? false,
  });
}

export function trackForRentPhoneContact(partialListing: Partial<ListingDetails>): void {
  FloodlightTracker.trackForRentPhoneContact(partialListing);
  FacebookPixel.trackForRentPhoneContact(partialListing);
  Adwords.trackForRentPhoneContact(partialListing);
  bing.trackForRentPhoneContact({
    trusted: partialListing.trusted ?? false,
    isApartmentBldg: partialListing.isApartmentBldg ?? false,
  });
}

export function trackPayPerClick(listing: Partial<ListingDetails>): void {
  FloodlightTracker.trackPayPerClick();
  FacebookPixel.trackPayPerClick(listing);
  Adwords.trackPayPerClick();
  bing.trackPayPerClick({
    trusted: listing.trusted ?? false,
    isApartmentBldg: listing.isApartmentBldg ?? false,
  });
}

export function trackListingView(listing: Partial<ListingDetails>): void {
  FloodlightTracker.trackListingView(listing);
  FacebookPixel.trackListingView(listing);
}

export function trackHomepageView(): void {
  FloodlightTracker.trackHomepageView();
  FacebookPixel.trackHomepageView();
}
